import { Grid, Skeleton } from '@mui/material';
import { useScreenSizes } from '@/hooks/use-screen-sizes';

export const LearningTypeListLoading = () => {
  const { desktopSize, isMediumScreen, isSmallScreen } = useScreenSizes();

  const numberOfItems = () => {
    if (isSmallScreen) return 2;
    if (isMediumScreen) return 3;
    if (desktopSize) return 4;
  };

  return (
    <Grid container spacing={3}>
      {Array.from(Array(numberOfItems())).map((_, n) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }} key={n}>
          <Skeleton
            data-testid="skeleton"
            sx={{ height: { xs: 100, sm: 200 } }}
            animation="wave"
            variant="rounded"
          />
        </Grid>
      ))}
    </Grid>
  );
};
